/** Read known string details from thrown SDK errors without assuming their shape. */
export const getErrorString = (error: unknown, key: "code" | "message"): string | undefined => {
  if (!error || typeof error !== "object" || !(key in error)) return undefined;
  const value: unknown = key === "code" && "code" in error ? error.code
    : key === "message" && "message" in error ? error.message : undefined;
  return typeof value === "string" ? value : undefined;
};
